import { ThumbsDown } from '@phosphor-icons/react';
import { XIcon, UserIcon, MessageCircleIcon, Loader2Icon } from 'lucide-react';

import { ThumbsDownIcon } from './ui/thumbs-down-icon';
import { ThumbsUpIcon } from './ui/thumbs-up-icon';

import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';
import { MesaReviewState } from '@/features/pulls/services/pulls';

interface ReviewAvatarProps {
  avatarUrl: string;
  reviewState?: MesaReviewState;
  className?: string;
  fallbackText?: string;
}

export function ReviewAvatar({ avatarUrl, reviewState, className, fallbackText }: ReviewAvatarProps) {
  // Get first letter for the fallback if fallbackText is provided
  const fallback = fallbackText ? fallbackText.charAt(0).toUpperCase() : undefined;

  return (
    <div className={`relative inline-block ${className || ''}`}>
      {/* Avatar */}
      <Avatar className="size-6">
        <AvatarImage src={avatarUrl} />
        <AvatarFallback>{fallback || <UserIcon className="size-4" />}</AvatarFallback>
      </Avatar>

      {/* Status overlay - only show for certain states */}
      {reviewState === 'APPROVED' && (
        <div className="absolute -bottom-1 -right-1 bg-white/70 rounded-full backdrop-blur-xs p-0.5">
          <ThumbsUpIcon filled className="size-3 text-emerald-500/100" />
        </div>
      )}

      {reviewState === 'CHANGES_REQUESTED' && (
        <div className="absolute -bottom-1 -right-1 bg-white/70 rounded-full backdrop-blur-xs p-0.5">
          <ThumbsDownIcon filled className="size-3 text-red-600" />
        </div>
      )}

      {reviewState === 'COMMENTED' && (
        <div className="absolute -bottom-1 -right-1 bg-white/70 rounded-full backdrop-blur-xs p-0.5">
          <MessageCircleIcon className="size-3 text-blue-600" />
        </div>
      )}

      {reviewState === 'AGENT_REVIEWING' && (
        <div className="absolute -bottom-1 -right-1 bg-white/70 rounded-full backdrop-blur-xs p-0.5">
          <Loader2Icon className="size-3 text-foreground animate-spin" />
        </div>
      )}
    </div>
  );
}
